import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circuit-resistor', 'CircuitResistor', [["path",{"d":"M2 12h2l2 -5l3 10l3 -10l3 10l3 -10l1.5 5h2.5"}]]);